// Función para calcular el rango de fechas de una semana
export function getWeekDateRange(weekNumber, year) {
    // Obtener el 4 de enero del año dado (para cumplir con la norma ISO 8601)
    const fourthOfJanuary = new Date(year, 0, 4);

    // Calcular el lunes de la primera semana ISO 8601 (restando los días necesarios para llegar al lunes)
    const firstMonday = new Date(fourthOfJanuary);
    firstMonday.setDate(fourthOfJanuary.getDate() - (fourthOfJanuary.getDay() + 6) % 7);
    // console.log(firstMonday)
    // Calcular el inicio de la semana deseada sumando (weekNumber - 1) * 7 días
    const startOfWeek = new Date(firstMonday);
    startOfWeek.setDate(firstMonday.getDate() + (weekNumber - 1) * 7);

    // Calcular el final de la semana (sumando 6 días al inicio)
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);

    return { start: startOfWeek, end: endOfWeek };
};

//Function to get de week number of a date
function getWeekNumber(date) {
    const tempDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    tempDate.setUTCDate(tempDate.getUTCDate() + 4 - (tempDate.getUTCDay() || 7));
    const yearStart = new Date(Date.UTC(tempDate.getUTCFullYear(), 0, 1));
    const weekNumber = Math.ceil(((tempDate - yearStart) / 86400000 + 1) / 7);

    return { weekNumber, year: tempDate.getUTCFullYear() };
}


// Functions for date formats
export function formatDate(date) {
    const options = { year: 'numeric', month: 'numeric', day: '2-digit' };
    return date.toLocaleDateString('es-ES', options);
};

export function formatDate2(date) {
    const options = { year: 'numeric', month: 'long', day: '2-digit' };
    return date.toLocaleDateString('es-ES', options);
};

export function formatDate3(date) {
    const options = { year: 'numeric', month: 'short', day: '2-digit' };
    return date.toLocaleDateString('es-ES', options);
};

